import { render } from "./categoryType.vue?vue&type=template&id=49c417ac&scoped=true"
import script from "./categoryType.vue?vue&type=script&lang=js"
export * from "./categoryType.vue?vue&type=script&lang=js"

import "./categoryType.vue?vue&type=style&index=0&id=49c417ac&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c417ac"]])

export default __exports__